import 'slick-carousel';
import timepicker from 'timepicker';
import cssVars from 'css-vars-ponyfill';
import modal from './modal';

global.timepicker = timepicker;
require('webpack-jquery-ui/datepicker');
require('bootstrap/js/dist/tab');

var rosterWindowWidth = $(window).width();
if(rosterWindowWidth < 769) {
    jQuery(".schedule-table").clone(true).appendTo('#schedule-scroll').addClass('clone');
}
if(rosterWindowWidth < 651){
    jQuery(".roster-table").clone(true).appendTo('#roster-scroll').addClass('clone');
}
if(rosterWindowWidth < 500){
    jQuery(".score-table").clone(true).appendTo('#score-scroll').addClass('clone');
}

$('.sportstable table tbody tr td a.view-details').click(function() {
    $('.scheduletable').hide();
    $('.game-details').show();
    if($(window).width() < 769) {
        $('.game-details-photos .photo-gallery').slick({
            dots: true,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            infinite: false,
            centerPadding: '30px',
        });
    }
});

$('.backto-schedule').click(function() {
    $('.scheduletable').show();
    $('.game-details').hide();
    if($(window).width() < 769) {
        $('.game-details-photos .photo-gallery').slick("unslick");
    }
});

$('.main-gallery .photo-wrapper a').click(function(e) {
    e.preventDefault();
    $('.main-gallery').hide();
    $('.album').show();
    $('.photos-tab-wrapper').addClass('show-back');
});

$('.album .album-header a.backto-details').click(function() {
    $('.photos-tab-wrapper').removeClass('show-back');
});

$('.photos-tab-wrapper .backto-album').click(function() {
    $('.main-gallery').show();
    $('.album').hide();
    $('.photos-tab-wrapper').removeClass('show-back');
});

$(window).on("load resize",function(e){
    //add something for resize
    if($(window).width() < 992) {
        $('.teamheader__info--contact').appendTo('.team-subnav--wrapper');
        $('.team-sport-header').appendTo('.teamheader__info');
    }
    else {
        $('.teamheader__info--contact').insertAfter('.teamheader__info h1');
        $('.team-sport-header').insertBefore('.sportstabs');
    }
 });

function initRevealMore(trigger, content, close, mobile) {
    trigger = $(trigger);
    close = $(close);

    var mobileWindowWidth = 992;

    var fadeRevealTansition = function(trigger, content, close) {
        $(content).hide();
        trigger.on('click', function(){
            $(content).fadeIn();
        });

        if(close.length) {
            close.on('click', function(){
                $(content).fadeOut();
            });
        }
    }

    var slideRevealTansition = function(trigger, content) {
        trigger
            .addClass('accordion__title')
            .attr({
                'role': 'tab',
                'aria-selected': 'false',
                'aria-expanded': 'false',
            });

        $(content)
            .attr({
                'role': 'tabpanel',
                'aria-hidden': 'true',
            })
            .hide();

        trigger.on('click', function(e){
            e.preventDefault();

            if (trigger.attr( 'aria-expanded') === 'true') {
                $(this).attr( 'aria-expanded', 'false');
            } else {
                $(this).attr( 'aria-expanded', 'true');
            }

            $(this).toggleClass('is-active');
            
            if($(this).prev(content).length) {
                $(this).prev(content).slideToggle();
            } else {
                $(this).next(content).slideToggle();
            }
            
        });
    }

    var fadeReveal = function(trigger, content, close, mobile) {
        if(mobile === true) {
            if($(window).width() <= mobileWindowWidth) {
                fadeRevealTansition(trigger, content, close);
            } else {
                $(content).show();
            }
        } else {
            fadeRevealTansition(trigger, content, close);
        }
    };

    var toggleReveal = function(trigger, content, close, mobile) {
        if(mobile === true) {
            trigger.on('click', function(){
                $(this).toggleClass('is-active');
                $(content).toggleClass('is-active');
            });

            if(close.length) {
                close.on('click', function(){
                    trigger.removeClass('is-active');
                    $(content).removeClass('is-active');
                });
            }
        } else {
            trigger.on('click', function(){
                $(this).toggleClass('is-active');
                $(content).toggleClass('is-active');
            });

            if(close.length) {
                close.on('click', function(){
                    trigger.removeClass('is-active');
                    $(content).removeClass('is-active');
                });
            }
        }
    };

    var slideReveal = function(trigger, content, mobile) {
        if(mobile === true) {
            if($(window).width() <= mobileWindowWidth) {
                slideRevealTansition(trigger, content);
            } else {
                $(content).show();
            }
        } else {
            slideRevealTansition(trigger, content);
        }
    };

    var revealType = trigger.data('reveal-type');
    switch (revealType) {
        case 'toggle':
            toggleReveal(trigger, content, close, mobile);
            break;
        case 'fade':
            fadeReveal(trigger, content, close, mobile);
            break;
        case 'slide':
            slideReveal(trigger, content, mobile);
            break;
    };
}

function initMovePieces(piece, locationDesk, locationMobile, screenSize) {
    
    function moveAction() {
        if($(window).width() > screenSize ){
            $(piece).appendTo(locationDesk);
        } else {
            $(piece).appendTo(locationMobile);
        }
    }
    
    moveAction();
    $(window).on('resize', function(){
        moveAction();
    });
}

function initPrintPage(printTrigger) {
    var trigger = $(printTrigger);

    trigger.on('click', function(){
        $(this).closest('.section').addClass('section--printed');
        window.print();
    });
}

function closeSubMenu(){
    $('.nav__item').each(function(){
        $(this).focus(function(){
            console.log('Focused');
            $('ul.focused').removeClass('focused');
            $(this).siblings('ul').addClass('focused');
        });
    });
}

function initThemeColor() {
    var changeElement = document.getElementsByTagName('html')[0];
    
    // Change hex code to RGB value
    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    
    // Determine color contrast based on RGB
    function setContrast(rgb) {
        // http://www.w3.org/TR/AERT#color-contrast
        var o = Math.round(((parseInt(rgb.r) * 299) +
                          (parseInt(rgb.g) * 587) +
                          (parseInt(rgb.b) * 114)) / 1000);
        var textColor = (o > 125) ? '#212529' : '#FFFFFF';
        return textColor;
    }
    
    // Change thematic colors for each team based on input from backend with hex code.
    if(document.getElementById('colorId')) {
        var colorValue = document.getElementById('colorId').value;
        if (colorValue){
            var textColorValue = setContrast(hexToRgb(colorValue));
            changeElement.style.setProperty('--theme-color', colorValue);
            changeElement.style.setProperty('--theme-text-color', textColorValue);
            
            // This is the Ponyfill(polyfill) for CSS Variables
            // Gets support for IE9 +
            // Documentation here - https://jhildenbiddle.github.io/css-vars-ponyfill/#/
            cssVars ({
                include: 'style,link[rel="stylesheet"]:not([href*="//"])',
                onlyLegacy: false,
                preserveVars: true,
                variables: {
                    '--theme-color' : colorValue, 
                    '--theme-text-color' : textColorValue
                }
            });
        }
    } else {
        changeElement.style.setProperty('--theme-color', '#3DA143');
        changeElement.style.setProperty('--theme-color', '#FFFFFF');
    }
}

$(document).ready(function () {

    //removing the wide wrpper class when this is on sportsnetwork, and adding the general samller padding container
    $('.sports-network .landing-page .landing-section .section > div').removeClass('wrapper').addClass('sportscontainer');
    
    // Don't like this. Had to be done to move the SportsNews title to correct place.
    var newsContainer = $('.js-sportsnews-title'),
        newsTitle = newsContainer.find('h2.theme');
    
    newsContainer.prepend(newsTitle);
    newsTitle.addClass('mb__0');

    // closeSubMenu();
    
    $('.team-subnav .mobile-only').click(function() {
        $(this).toggleClass('menu-open');
        $('.team-subnav--wrapper').slideToggle('.3s');
    });
    
    if($(window).width() > 769) {
        $('.calendar-view .title-style').appendTo('.js-month-placeholder');
    }
    
    initRevealMore('.js-view-events', '.js-hidden-events', '', false);
    initRevealMore('.js-view-list', '.js-list-hidden', '', true);
    initRevealMore('.js-filter-trigger', '.js-filter-content', '', true);
    
    initMovePieces('.js-move-pager', '.js-pager-dekstop', '.js-pager-mobile', 992);
    
    initThemeColor();
    
    modal.initModal('.js-photo-gallery');
    
    //initPrintPage('.js-print-page');
    $('.js-mob-menu-trigger').click(function(){
        $(this).toggleClass('active');
        if($('.js-mob-menu').is(':visible')){
            $('html').css('overflow', 'scroll');
        } else{
            $('html').css('overflow', 'hidden');
        }
        $('.js-mob-menu').slideToggle();
    });

    $('.js-nav .nav__item').each(function(){
        if($(this).siblings('ul').length > 0){
            $(this).addClass('hasChildren');
        }
    });
    
    $('.team-subnav .nav__group .hasChildren').on('click', function(e) {
        //console.log('clicked');
        e.preventDefault();
        $(this).toggleClass('menu-open');
        $(this).siblings('ul.list-blank').slideToggle('.3s');
    });
});
